import { render, staticRenderFns } from "./Rep_dinamico.vue?vue&type=template&id=22408a52&scoped=true"
import script from "./Rep_dinamico.vue?vue&type=script&lang=js"
export * from "./Rep_dinamico.vue?vue&type=script&lang=js"
import style0 from "./Rep_dinamico.vue?vue&type=style&index=0&id=22408a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22408a52",
  null
  
)

export default component.exports